<h2
  mat-dialog-title
  class="!text-2xl !font-semibold !text-slate-900 !p-4 !font-sans"
>
  Create New List
</h2>
<mat-dialog-content>
  <div [formGroup]="form" class="space-y-5">
    <div class="space-y-1.5">
      <label
        for=""
        class="text-xs font-bold text-slate-500 uppercase tracking-wider"
        >List Name</label
      >
      <input
        type="text"
        formControlName="name"
        class="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-slate-800 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all"
      />
      @if (form.controls.name.invalid && form.controls.name.touched) {
      <span class="text-xs text-red-500">Name is required</span>
      }
    </div>

    <div class="space-y-1.5">
      <label
        for=""
        class="text-xs font-bold text-slate-500 uppercase tracking-wider"
        >List Type</label
      >
      <div class="grid grid-cols-2 gap-3">
        <!-- Hidden form control that stores the value -->
        <select class="hidden" formControlName="list_type">
          <option [value]="ListType.NORMAL_LIST">Normal List</option>
          <option [value]="ListType.CONSTRUCTED_LIST">Constructed</option>
        </select>

        <!-- Visual buttons that update the control -->
        <button
          type="button"
          (click)="form.controls.list_type.setValue(ListType.NORMAL_LIST)"
          [class]="form.controls.list_type.value === ListType.NORMAL_LIST ? 'border-blue-500 bg-blue-50/30' : 'border-slate-200 bg-white'"
          class="flex flex-col text-left p-3 rounded-xl border-2 transition-all"
        >
          <span
            [class]="form.controls.list_type.value === ListType.NORMAL_LIST ? 'text-blue-700' : 'text-slate-700'"
            class="text-sm font-semibold"
            >Normal List</span
          >
          <span class="text-[11px] opacity-70 leading-tight"
            >Regular list items</span
          >
        </button>

        <button
          type="button"
          (click)="form.controls.list_type.setValue(ListType.CONSTRUCTED_LIST)"
          [class]="form.controls.list_type.value === ListType.CONSTRUCTED_LIST ? 'border-blue-500 bg-blue-50/30' : 'border-slate-200 bg-white'"
          class="flex flex-col text-left p-3 rounded-xl border-2 transition-all"
          [disabled]="true"
        >
          <span
            [class]="form.controls.list_type.value === ListType.CONSTRUCTED_LIST ? 'text-blue-700' : 'text-slate-700'"
            class="text-sm font-semibold"
            >Constructed List</span
          >
          <span class="text-[11px] opacity-70 leading-tight"
            >Dynamic/calculated list</span
          >
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions [align]="'end'">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="form.invalid"
    (click)="confirmAddList()"
  >
    Create List
  </button>
</mat-dialog-actions>
